import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogLocationService } from '../../dialogs/dialog-location/dialog-locations.service';
import { FilterLocationsComponent } from '../../filter/filter-locations.component';
import { LocationService } from '../../services/location.service';
import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';
var DatatableLocationsComponent = /** @class */ (function () {
    function DatatableLocationsComponent(locationService, dialogLocationService, fuseTranslationLoaderService) {
        this.locationService = locationService;
        this.dialogLocationService = dialogLocationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.totalCountLocations = new EventEmitter();
        this.locations = [];
        this.filtered = false;
        this.loading = true;
        this.displayedColumns = ['name', 'streetName', 'edit'];
        this.subscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DatatableLocationsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.loading = true;
                this.sort.active = 'name';
                this.sort.direction = 'asc';
                merge(this.sort.sortChange, this.paginator.page, this.reload, this.filters.filtersChanged.pipe(tap(function () { return _this.paginator.firstPage(); })))
                    .pipe(takeUntil(this.subscriptions), debounceTime(1000), switchMap(function () {
                    _this.loading = true;
                    _this.sort.direction = _this.sort.direction || 'asc';
                    var options = {
                        orderBy: {
                            column: _this.sort.active,
                            direction: _this.sort.direction
                        },
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    var where = _this.filters.filtersChanged.value;
                    return _this.locationService.loadData({
                        where: where,
                        options: options
                    });
                }))
                    .subscribe(function (result) {
                    _this.datatable.nativeElement.scrollTo({
                        top: 0,
                    });
                    _this.loading = false;
                    _this.filtered = result.filtered;
                    _this.locations = result.items;
                    _this.totalCount = result.totalCount;
                    _this.totalCountLocations.emit(_this.totalCount);
                });
                return [2 /*return*/];
            });
        });
    };
    DatatableLocationsComponent.prototype.openDialog = function (locationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialogLocationService.open({ locationId: locationId })];
                    case 1:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.reload.next();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DatatableLocationsComponent;
}());
export { DatatableLocationsComponent };
